
import { useI18n } from "vue-i18n/index";
import { defineComponent, ref,onMounted,provide,computed, inject} from 'vue'
import { useRoute} from 'vue-router';
import { useStore } from "vuex";
//components
import btnBack from "@/components/buttons/btnBack.vue"

//services
import GlobalService from "@/core/services/GlobalService";
import {
    errManager,
    dateParticipate,
    DownloadXLSXPDF,
    mbtoa
} from "@/core/config/Tools";

export default defineComponent({
    name: "acrd-manager",
    components: {
        btnBack,
    },
    setup() {
        const { t } = useI18n();
        const store = useStore();
        const route = useRoute();
        const loader = ref(false)
        const evento = ref<any>({})
        const { id } = route.params;
        const idcheckdoc = ref<any[]>([]);
        provide("evento", evento);
        provide("idcheckdoc", idcheckdoc);

        const company = computed(() => {
            return store.getters.currentUser.company
        });

        //detalle del evento
        const getDetails = async () => {
            loader.value = true
            await GlobalService.get(`api/events/${id}`, 'show')
                .then((res) => {
                    evento.value = res.data
                    loader.value = false
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        };
        onMounted(() => {
            getDetails();
        })

        return {
            t,
            loader,
            id,
            evento,
            idcheckdoc,
            //events
            company,
            mbtoa,
            dateParticipate,
            getDetails,
            DownloadXLSXPDF
        }
    }
})
